module.exports = __webpack_public_path__ + "static/media/pe-2.ae8c999c.jpg";